import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";
import { Card, Spinner, FormGroup } from "reactstrap";
import {
    Button,
    Block,
    Row,
    Col,
    Icon,
} from "../../../components/Component";
import Swal from "sweetalert2";
import Head from "../../../layout/head/Head";
import OptionM from "../../components/DynmicOption/OptionM";
import OptionC from "../../components/DynmicOption/OptionC";
import ES3Update from "./ES3Update";
import { DownloadTableExcel } from 'react-export-table-to-excel';

const ES3DataView = ({ ...props }) => {
    const [dataactive, setdataactive] = useState([]);
    const [Totall, setTotal] = useState([]);
    const [GTotal, setGTotal] = useState(0);
    const [userData, setuserData] = useState("");
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const [employmentId, setemloymentId] = useState(sessionStorage.getItem("employmentId"));
    const today = new Date();
    const tableRef = useRef(null);
    const [Draft, setDraft] = useState(true);
    const [loading, setloading] = useState(false);
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: sessionStorage.getItem("EmploymentRefId"),
    });
    const onInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        //console.log(formData)
    };
    const Total = async (empId) => {

        const sendData = {

            EmploymentId: Number(empId),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/GetES3DetailsTotal1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data[0])
                    setTotal(data[0])
                })


    };
    const getdata2 = async (emp) => {

        const sendData = {

            EmploymentId: Number(emp),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GetEs3param', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data)
                    setdataactive(data)
                })


    };
    const getdata = async () => {

        const sendData = {
            EmploymentId: Number(employmentId),
            UserId: Number(localStorage.getItem("userId")),
        }


        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Viewalldata', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    if (data === "NO") {
                        setloading(false)
                        setDraft(true)

                    }
                    else {
                        setloading(false)
                        setDraft(false)
                        setemloymentId(data.employmentId)
                        getdata2(data.employmentId)
                        Total(data.employmentId)
                        setuserData(data)

                    }

                })


    };
    const generate = async () => {
        if (formData.year > 0 && formData.month > 0) {
            setloading(false)
            const sendData = {
                UserId: Number(localStorage.getItem("userId")),
                EmploymentRefId: Number(formData.EmploymentRefId),
                YearId: Number(formData.year),
                MonthId: Number(formData.month),
            }
            //console.log(sendData)

            await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GenerateEs3', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(sendData)

            })
                .then(response => response.json())
                .then(
                    data => {
                        if (data === "Error") {
                            Swal.fire({
                                title: ' This Month Report is Already Submitted',
                                icon: 'error',

                            })
                        } else {
                            setloading(false)
                            getdata()
                        }

                    })
        } else {
            Swal.fire({
                icon: "warning",
                title: "Month or Year Not Selected",
                text: "Please Select Month and Year",
                focusConfirm: false,
            }).then(() => {
                props.history.push("/Dashboard")
            })
        }

    };
    useEffect(() => {
        if (employmentId > 0) {
            Total(employmentId)

        }
    }, [GTotal])
    useEffect(() => {

        setloading(true)
        getdata()
    }, [])
    const onFormSubmit = async () => {

        Swal.fire({
            title: 'Are You Sure you want to Submit  ?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            confirmButtonColor: 'success',
            denyButtonText: `No`,
        }).then(async (result) => {

            if (result.isConfirmed) {
                const sendData = {

                    EmploymentId: employmentId,
                }

                //console.log(sendData)
                await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Submitform', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendData)

                })
                    .then(response => response.json())
                    .then(
                        data => {
                            if (data === "Done") {
                                props.history.push("/Dashboard")
                            } else {
                                Swal.fire({
                                    title: 'Data Not Submitted',
                                    icon: 'error',

                                })
                            }

                        })


            } else if (result.isDenied) {
                getdata()
            }
        })



    };

    const onSaveDraft = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        getdata()



    };
    const onSaveDraftGoBack = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        props.history.push("/Dashboard")
        getdata()



    };
    const ADDDynamic = async () => {
        setloading(false)
        const sendData = {
            EmploymentId: employmentId,
            EmploymentRefId: Number(formData.EmploymentRefId),

        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/DynamicAddEs3', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data == 'Done') {
                        setloading(true)
                        getdata()
                    } else {
                        window.location.reload()
                    }

                })


    };


    return (
        <React.Fragment>
            <Head title="AllUser" />
            <Content>
                {loading ? <Spinner color="success" /> :
                    <Block>
                        <Button onClick={() => window.location.href = '/Dashboard'} color="dark">BACK</Button>
                        <Card className="card-bordered card-stretch" style={{ padding: 20 }}>
                            {/*<NavbarDynamic/>*/}
                            {localStorage.getItem("urole") === "7" ?<h3 style={{ marginBottom: 40 }}>Employment Return (ES3)    <DownloadTableExcel
                                filename={userData.user !== undefined ? "ES3 Report-" + userData.user.state : "ES3 Report"}
                                sheet="users"
                                currentTableRef={tableRef.current}
                            >
                                <Button style={{ float: "right" }} color="info" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>
                            </DownloadTableExcel>  </h3>:<h3 style={{ marginBottom: 40 }}>Employment Return (ES3)    <DownloadTableExcel
                                filename="ES3 Report"
                                sheet="users"
                                currentTableRef={tableRef.current}
                            >
                                <Button style={{ float: "right" }} color="info" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>
                            </DownloadTableExcel>  </h3>}

                            {Draft ? <Row className="gy-4">
                                <Col md="6">
                                    <OptionM catid="41" defaultValuemain={formData.dummymonth} onInputChange={onInputChange} namemain="month" mainid="month" />
                                </Col>
                                <Col md="6">
                                    <OptionC catid="42" defaultValuemain={formData.year} onInputChange={onInputChange} namemain="year" mainid="year" />
                                </Col>
                                <Col md="6">
                                    <Button color="success" onClick={() => generate()} >Generate</Button>
                                </Col>
                            </Row> :
                                <Card style={{ marginTop: 20, border: "2px solid black", padding: 10 }} className="card-bordered card-stretch">
                                    <Row className="gy-4">
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Center: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.state : "Not Specified"}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Name of Employment Exchange: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.answer1 : "Not Specified"}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Month: <label style={{ fontWeight: "normal" }}> {month1[userData.monthId]}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    ES 3: Return showing the work done by the Employment Exchanges by NCO: <label style={{ fontWeight: "normal" }}>  </label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <div className="card-inner-group" style={{ border: '2px solid black', padding: 2 }}>

                                        <div style={{ height: window.innerHeight - 300, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                                            <table className="table" ref={tableRef} style={{ borderCollapse: "separate", borderSpacing:0 }}>
                                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                                    <div style={{ visibility: 'hidden', height: 0, width: 0 }}> <tr ><center> Center Name -{userData.user !== undefined ? userData.user.state : "Not Specified"}</center></tr></div>
                                                    <tr >

                                                        <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            S. No.

                                                        </th>
                                                        <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                            8 digit NCO-2015
                                                        </th>
                                                        <th colSpan="7" rowSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            No of applicants on the Live Register at the end of the  month in respect of

                                                        </th>
                                                        <th colSpan="28" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Number of Vacancies
                                                        </th>


                                                    </tr>
                                                    <tr>

                                                        <td colSpan="7" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} > Notified upto the current month</td>
                                                        <td colSpan="7" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} > Filled upto the current month</td>
                                                        <td colSpan="7" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} > Cancelled upto the current month</td>
                                                        <td colSpan="7" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} > Outstanding upto the current month</td>

                                                    </tr><tr>

                                                        <td colSpan="7" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} > in respect of</td>
                                                        <td colSpan="7" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} > in respect of</td>
                                                        <td colSpan="7" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} > in respect of</td>
                                                        <td colSpan="7" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} > in respect of</td>

                                                    </tr><tr>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Women</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > Transgender</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > PWD</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Women</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > Transgender</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > PWD</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Women</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > Transgender</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > PWD</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Women</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > Transgender</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > PWD</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >Women</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > Transgender</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 100 }} > PWD</td>

                                                    </tr>

                                                </thead>

                                                <tbody>

                                                    {dataactive !== [] ? dataactive.map((details) =>

                                                        details.parentId === 0 ?
                                                            <tr scope="row" >

                                                                <td >

                                                                    <b>  {details.value}</b>

                                                                </td>



                                                            </tr> :
                                                            <ES3Update value={details.value} setGTotal={setGTotal} GTotal={GTotal} edit={false} es3detailsId={details.es3detailsId} employmentId={employmentId} ES3Update={ES3Update} />

                                                    ) : null}
                                                   
                                                    <tr scope="row" >



                                                        <td>

                                                            <b>  Total</b>

                                                        </td>
                                                        <td></td>
                                                        {/*<td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall._8DigitNco20152}
                                                        </td>*/}
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.total3}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.women4}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.transgender5}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.sc6}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.st7}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.obc8}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.pwd9}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.tota10}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.women11}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.transgender12}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.sc13}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.st14}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.obc15}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.pwd16}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.total17}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.women18}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.transgender19}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.sc20}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.st21}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.obc22}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.pwd23}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.total24}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.women25}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.transgender26}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.sc27}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.st28}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.obc29}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.pwd30}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.total31}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.women32}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.transgender33}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.sc34}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.st35}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.obc36}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.pwd37}
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>

                                        </div>



                                    </div>
                                    
                                </Card>}



                        </Card>

                    </Block>}

            </Content>

        </React.Fragment>
    );
};

export default ES3DataView;
